import React from 'react';
import { Bell, MessageSquare, FileSignature, CreditCard, Star } from 'lucide-react';

const ICON_FOR_TYPE = {
  message: MessageSquare,
  lease_signed: FileSignature,
  lease_countersigned: FileSignature,
  payment_received: CreditCard,
  review: Star,
};

function formatWhen(iso) {
  return new Date(iso).toLocaleString([], {
    month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit',
  });
}

export default function NotificationItem({ notif, idx, onClick }) {
  const Icon = ICON_FOR_TYPE[notif.type] || Bell;
  const isUnread = !notif.read;
  return (
    <div
      data-testid={`notification-${idx}`}
      onClick={() => onClick(notif)}
      className={`p-4 border-b border-border cursor-pointer hover:bg-muted ${isUnread ? 'bg-accent/5' : ''}`}
    >
      <div className="flex gap-3">
        <div className={`w-10 h-10 rounded-full flex items-center justify-center shrink-0 ${isUnread ? 'bg-accent/10 text-accent' : 'bg-muted text-muted-foreground'}`}>
          <Icon className="w-5 h-5" />
        </div>
        <div className="flex-1 min-w-0">
          <div className="font-medium text-sm">{notif.title}</div>
          <div className="text-sm text-muted-foreground truncate">{notif.message}</div>
          <div className="text-xs text-muted-foreground mt-1">{formatWhen(notif.created_at)}</div>
        </div>
        {isUnread && <div className="w-2 h-2 rounded-full bg-accent shrink-0 mt-2" />}
      </div>
    </div>
  );
}
